import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';

import { CurrentTheme, MagstimDropdown } from "common";
import MagstimInputGroup from './MagstimInputGroup'

class MagstimInputGroupDropDown extends MagstimInputGroup {

    render() {

        return(
            <>
            <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                <InputGroupText>{this.props.title}</InputGroupText>
            </InputGroupAddon>
            <InputGroup size={CurrentTheme().ControlSize}>
                <InputGroupAddon addonType="prepend"  className="d-none d-md-block">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>

                <MagstimDropdown size={CurrentTheme().ControlSize} ref={this.props.dropDownRef} disabled={this.props.disabled} onSelect={this.props.onSelect}>
                    {this.props.options.map(option => (
                        this.dropdownItem(option, this.props.default)
                    ))}
                </MagstimDropdown>

            </InputGroup>
            </>
        );
    }
}

MagstimInputGroupDropDown.propTypes = {
    title: PropTypes.string,
    options:PropTypes.array,
    default:PropTypes.string,
    dropDownRef:PropTypes.object,
    disabled:PropTypes.bool,
    onSelect:PropTypes.func
};

MagstimInputGroupDropDown.defaultProps = {
    title: "",
    options:[],
    default:"",
    dropDownRef:undefined,
    disabled:false,
    onSelect:undefined
};

export default MagstimInputGroupDropDown